<template>
  <div
    v-if="isLoading"
    class="faq-modal-v2__loader"
  >
    <loader />
  </div>
  <div class="faq-modal-v2__header">
    <div class="faq-modal-v2__header-title">
      {{ title }}
    </div>
    <div
      class="faq-modal-v2__header-close"
      @click="close"
    >
      <sprite
        class="faq-modal-v2__header-close-icon"
        src="sprites_cross"
      />
    </div>
  </div>

  <div class="faq-modal-v2__body">
    <faq :questions="questions" />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
// import apiVcp from '@/api/faq'

import Loader from '@/components/core/ui/Loader'

import Faq from '@/components/dashboard/Faq'
export default {
  name: 'FaqModal',
  components: {
    Faq,
    Loader,
  },
  props: {
    category: {
      type: String,
      default: 'common',
    },
  },
  emits: ['close'],
  data () {
    return {
      isLoading: false,
      questions: [],
      title: 'Частые вопросы',
    }
  },
  computed: {
  },
  created () {
    this.getFaq()
  },
  methods: {
    ...mapActions({
      getFAQ: 'marketing/getFAQ',
    }),
    close () {
      this.$emit('close')
    },
    async getFaq () {
      this.isLoading = true
      this.getFAQ(this.category).then(({
        faq: {
          title,
          categories,
        } = {
          title: '',
          categories: [],
        },
        success = false,
        messages,
      }) => {
        const questions = []
        categories.forEach(item => {
          item.questions.forEach(question => {
            questions.push(question)
          })
        })
        if (
          success &&
          questions &&
          questions.length > 0
        ) {
          this.title = title
          this.questions = questions
        } else {
          this.close()
          if (messages) {
            messages.forEach((message) => {
              this.toast({ group: 'error', title: message })
            })
          } else {
            this.toast({ group: 'error', title: 'Ошибка загрузки' })
          }
        }
        this.isLoading = false
      }, () => {
        this.close()
        this.isLoading = false
      })
    },
  },
}
</script>

<style lang="scss">
.faq-modal-v2 {
  font-size: .16rem;
  width: 100%;
  height: 100%;
  border-radius: 0;
  &__loader {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: map-get($colors, 'white');;
  }
  &__header {
    background-color: map-get($colors, 'white');
    padding: 0.12rem 0.16rem;
    box-shadow: 0 0.02rem 0.04rem rgba(0, 0, 0, 0.05);
  }
  &__header-title {
    @include typography('b1', '500');
  }
  &__header-close {
    position: absolute;
    right: 0;
    top: 0;
    padding: .16rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__header-close-icon {
    width: .14rem;
    height: .14rem;
  }
  &__btn {
    margin: .32rem auto 0;
  }
}
</style>
